
import Vue from 'vue';
import App from './App.vue';
import i18n from './i18n'
import router from './router';

/***********************引入Leaflet工具包************************** */
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
//import 'leaflet-moving-rotated-marker';
import 'leaflet.chinesetmsproviders';
import marker from './assets/publicroad/dot.png';

console.log("Vue Version: " + Vue.version);  // 2.6.11

//设置marker标注
let defaultIcon = L.icon({
  iconUrl: marker,
  iconSize: [30, 30],
  //iconAnchor: [40, 48],
});

L.Marker.prototype.options.icon = defaultIcon;

Vue.prototype.L = L;
Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app');

/*
import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
*/